const common = {
  // General
  loading: 'Yükleniyor...',
  save: 'Kaydet',
  cancel: 'İptal',
  delete: 'Sil',
  edit: 'Düzenle',
  add: 'Ekle',
  search: 'Ara',
  filter: 'Filtrele',
  all: 'Tümü',
  active: 'Aktif',
  inactive: 'Pasif',
  yes: 'Evet',
  no: 'Hayır',
  confirm: 'Onayla',
  back: 'Geri',
  next: 'İleri',
  previous: 'Önceki',
  close: 'Kapat',
  submit: 'Gönder',
  reset: 'Sıfırla',
  view: 'Görüntüle',
  details: 'Detaylar',
  actions: 'İşlemler',
  status: 'Durum',
  date: 'Tarih',
  time: 'Saat',
  name: 'İsim',
  email: 'E-posta',
  phone: 'Telefon',
  address: 'Adres',
  description: 'Açıklama',
  price: 'Fiyat',
  image: 'Görsel',
  title: 'Başlık',
  category: 'Kategori',
  order: 'Sıralama',
  created: 'Oluşturulma',
  updated: 'Güncellenme',

  // Navigation
  nav: {
    home: 'Ana Sayfa',
    services: 'Hizmetler',
    about: 'Hakkımızda',
    contact: 'İletişim',
    appointment: 'Randevu Al',
    gallery: 'Galeri',
    login: 'Giriş Yap',
    logout: 'Çıkış Yap',
    register: 'Kayıt Ol',
    admin: 'Yönetim Paneli'
  },

  // Home Page
  home: {
    hero: {
      title: 'Aracınızı Yeni Gibi Yapın',
      subtitle: 'Profesyonel otomotiv yenileme ve detaylı temizlik hizmetleri ile aracınızın değerini artırın',
      cta: 'Randevu Al',
      services: 'Hizmetlerimiz'
    },
    stats: {
      customers: 'Mutlu Müşteri',
      experience: 'Yıllık Deneyim',
      services: 'Hizmet Sayısı',
      rating: 'Müşteri Memnuniyeti'
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Aracınız için en iyi bakım ve yenileme hizmetleri',
      viewAll: 'Tüm Hizmetleri Gör'
    },
    features: {
      title: 'Neden Bizi Seçmelisiniz?',
      subtitle: 'Kalite ve güvenin adresi'
    },
    quality: {
      feature1: 'Premium Kalite',
      feature1Desc: 'En kaliteli ürünler ve profesyonel ekipmanlarla hizmet veriyoruz',
      feature2: 'Garanti',
      feature2Desc: 'Tüm hizmetlerimiz garanti kapsamındadır',
      feature3: 'Hızlı Teslimat',
      feature3Desc: 'Zamanında ve hızlı teslimat garantisi'
    },
    process: {
      title: 'Nasıl Çalışıyoruz?',
      subtitle: 'Basit ve etkili süreç',
      step1: 'Randevu Alın',
      step1Desc: 'Online veya telefonla kolayca randevu oluşturun',
      step2: 'Aracınızı Getirin',
      step2Desc: 'Belirlenen tarihte aracınızı teslim edin',
      step3: 'İşlem Yapılır',
      step3Desc: 'Uzman ekibimiz aracınıza özenle bakar',
      step4: 'Teslim Alın',
      step4Desc: 'Yenilenen aracınızı teslim alın'
    },
    gallery: {
      title: 'Çalışmalarımız',
      subtitle: 'Önceki projelerimizden örnekler'
    },
    testimonials: {
      title: 'Müşteri Yorumları',
      subtitle: 'Müşterilerimiz ne diyor?'
    },
    team: {
      title: 'Ekibimiz',
      subtitle: 'Uzman kadromuzla tanışın'
    },
    cta: {
      title: 'Aracınız İçin En İyisini Hak Ediyor',
      subtitle: 'Hemen randevu alın ve farkı görün',
      button: 'Randevu Al'
    }
  },

  // Services Page
  services: {
    hero: {
      title: 'Hizmetlerimiz',
      subtitle: 'Aracınız için profesyonel bakım ve yenileme çözümleri'
    },
    cta: {
      title: 'Aracınız İçin En İyisini Hak Ediyor',
      subtitle: 'Profesyonel ekibimizle tanışın ve aracınızı yenileyin',
      button: 'Randevu Al'
    },
    loading: 'Yükleniyor...',
    features: 'Özellikler',
    bookNow: 'Randevu Al',
    detail: {
      features: 'Özellikler',
      duration: 'Süre',
      gallery: 'Galeri',
      bookNow: 'Randevu Al',
      relatedServices: 'İlgili Hizmetler'
    }
  },

  // About Page
  about: {
    hero: {
      title: 'Hakkımızda',
      subtitle: '2009\'dan beri otomotiv yenileme alanında mükemmellik'
    },
    story: {
      title: 'Hikayemiz',
      text: 'Profesyonel otomotiv bakım ve yenileme hizmetleri sunuyoruz.'
    },
    mission: {
      title: 'Misyonumuz',
      text: 'Müşterilerimizin beklentilerini aşan olağanüstü hizmetler sunmak.'
    },
    vision: {
      title: 'Vizyonumuz',
      text: 'Sektörde lider ve güvenilir bir marka olmak.'
    },
    values: {
      title: 'Değerlerimiz',
      subtitle: 'Bizi yönlendiren temel ilkeler',
      excellence: 'Mükemmellik',
      excellenceDesc: 'Her projede en yüksek standartları koruyoruz',
      integrity: 'Dürüstlük',
      integrityDesc: 'Şeffaflık ve dürüstlük ilkesiyle çalışıyoruz',
      innovation: 'Yenilikçilik',
      innovationDesc: 'Sürekli gelişim ve yenilik peşindeyiz',
      passion: 'Tutku',
      passionDesc: 'İşimize ve müşterilerimize tutkuyla bağlıyız'
    }
  },

  // Contact Page
  contact: {
    hero: {
      title: 'İletişim',
      subtitle: 'Herhangi bir sorunuz için ekibimizle iletişime geçin'
    },
    form: {
      title: 'İletişim Formu',
      name: 'Adınız Soyadınız',
      email: 'E-posta Adresiniz',
      phone: 'Telefon Numaranız',
      subject: 'Konu',
      message: 'Mesajınız',
      submit: 'Mesaj Gönder',
      sending: 'Gönderiliyor...',
      success: 'Mesajınız başarıyla gönderildi!',
      error: 'Bir hata oluştu, lütfen tekrar deneyin'
    },
    info: {
      title: 'İletişim Bilgileri',
      address: 'Adres',
      phone: 'Telefon',
      email: 'E-posta',
      hours: 'Çalışma Saatleri'
    },
    subjects: {
      general: 'Genel Bilgi',
      service: 'Hizmet Hakkında',
      quote: 'Fiyat Teklifi',
      feedback: 'Geri Bildirim'
    }
  },

  // Appointment Page
  appointment: {
    hero: {
      title: 'Randevu Alın',
      subtitle: 'Size uygun tarih ve saati seçerek kolayca randevu oluşturun'
    },
    form: {
      personalInfo: 'Kişisel Bilgiler',
      name: 'Ad Soyad',
      namePlaceholder: 'Adınızı ve soyadınızı girin',
      email: 'E-posta',
      emailPlaceholder: 'E-posta adresinizi girin',
      phone: 'Telefon',
      phonePlaceholder: 'Telefon numaranızı girin',
      service: 'Hizmet',
      selectService: 'Hizmet seçin',
      appointmentDetails: 'Randevu Detayları',
      date: 'Tarih',
      time: 'Saat',
      selectTime: 'Saat seçin',
      vehicleInfo: 'Araç Bilgileri',
      brand: 'Marka / Model / Yıl',
      brandPlaceholder: 'Örn: BMW 320i 2020',
      notes: 'Notlar',
      notesPlaceholder: 'Eklemek istediğiniz özel notlar...',
      submit: 'Randevu Oluştur',
      booking: 'Randevu oluşturuluyor...',
      success: 'Randevunuz başarıyla oluşturuldu!',
      error: 'Bir hata oluştu, lütfen tekrar deneyin'
    },
    contact: {
      call: 'Bizi Arayın',
      emailLabel: 'E-posta Gönderin',
      hours: 'Çalışma Saatleri',
      hoursText: 'Pazartesi - Cuma: 08:00 - 18:00\nCumartesi: 10:00 - 17:00\nPazar: Kapalı'
    }
  },

  // Footer
  footer: {
    quickLinks: 'Hızlı Bağlantılar',
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    services: 'Hizmetler',
    contact: 'İletişim',
    appointment: 'Randevu Al',
    workingHours: 'Çalışma Saatleri',
    defaultHours: 'Pazartesi - Cuma: 08:00 - 18:00\nCumartesi: 10:00 - 17:00\nPazar: Kapalı',
    contactInfo: 'İletişim Bilgileri',
    followUs: 'Bizi Takip Edin',
    allRightsReserved: 'Tüm hakları saklıdır.'
  },

  // Admin Panel
  admin: {
    title: 'Yönetim Paneli',
    viewSite: 'Siteyi Görüntüle',
    logout: 'Çıkış Yap'
  },

  // Dashboard
  dashboard: {
    title: 'Kontrol Paneli',
    welcome: 'Yönetim paneline hoş geldiniz',
    stats: {
      totalAppointments: 'Toplam Randevu',
      pendingAppointments: 'Bekleyen Randevu',
      totalServices: 'Toplam Hizmet',
      totalTestimonials: 'Toplam Yorum'
    },
    recentAppointments: 'Son Randevular',
    viewAll: 'Tümünü Gör',
    noAppointments: 'Henüz randevu bulunmuyor'
  },

  // Appointments
  appointments: {
    title: 'Randevular',
    subtitle: 'Tüm randevuları yönetin',
    search: 'Müşteri adı, e-posta veya hizmet ara...',
    all: 'Tümü',
    pending: 'Bekliyor',
    confirmed: 'Onaylandı',
    completed: 'Tamamlandı',
    cancelled: 'İptal Edildi',
    list: 'Liste',
    calendar: 'Takvim',
    customer: 'Müşteri',
    service: 'Hizmet',
    vehicle: 'Araç',
    date: 'Tarih',
    time: 'Saat',
    status: 'Durum',
    actions: 'İşlemler',
    noAppointments: 'Randevu bulunamadı',
    viewDetails: 'Detayları Gör',
    edit: 'Düzenle',
    whatsapp: 'WhatsApp ile İletişim',
    deleteConfirm: 'Bu randevuyu silmek istediğinizden emin misiniz?',
    details: {
      title: 'Randevu Detayları',
      customerInfo: 'Müşteri Bilgileri',
      vehicleInfo: 'Araç Bilgileri',
      appointmentInfo: 'Randevu Bilgileri',
      notes: 'Notlar',
      createdAt: 'Oluşturulma Tarihi'
    },
    edit: {
      title: 'Randevuyu Düzenle',
      save: 'Kaydet',
      success: 'Randevu başarıyla güncellendi!'
    }
  },

  // Auth
  auth: {
    login: {
      title: 'Giriş Yap',
      subtitle: 'Hesabınıza giriş yapın',
      email: 'E-posta',
      password: 'Şifre',
      submit: 'Giriş Yap',
      forgotPassword: 'Şifremi Unuttum',
      noAccount: 'Hesabınız yok mu?',
      register: 'Kayıt Ol',
      error: 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.'
    },
    register: {
      title: 'Kayıt Ol',
      subtitle: 'Yeni hesap oluşturun',
      name: 'Ad Soyad',
      email: 'E-posta',
      password: 'Şifre',
      confirmPassword: 'Şifre Tekrar',
      submit: 'Kayıt Ol',
      hasAccount: 'Zaten hesabınız var mı?',
      login: 'Giriş Yap',
      success: 'Kayıt başarılı! Giriş yapabilirsiniz.',
      error: 'Kayıt başarısız. Lütfen tekrar deneyin.'
    }
  },

  // Messages
  messages: {
    title: 'Mesajlar',
    subtitle: 'Gelen mesajları yönetin',
    noMessages: 'Henüz mesaj bulunmuyor',
    new: 'Yeni',
    read: 'Okundu',
    replied: 'Yanıtlandı',
    markAsRead: 'Okundu İşaretle',
    reply: 'Yanıtla',
    delete: 'Sil'
  },

  // Videos
  videos: {
    title: 'Videolar',
    subtitle: 'Video içeriklerinizi yönetin',
    noVideos: 'Henüz video eklenmemiş',
    addNew: 'Yeni Video Ekle',
    edit: 'Düzenle',
    delete: 'Sil'
  },

  // Banners
  banners: {
    title: 'Banner Yönetimi',
    subtitle: 'Ana sayfa bannerlarını yönetin',
    noBanners: 'Henüz banner eklenmemiş',
    addNew: 'Yeni Banner Ekle',
    edit: 'Düzenle',
    delete: 'Sil'
  },

  // Team
  team: {
    title: 'Ekip Yönetimi',
    subtitle: 'Ekip üyelerinizi yönetin',
    noMembers: 'Henüz ekip üyesi eklenmemiş',
    addNew: 'Yeni Üye Ekle',
    edit: 'Düzenle',
    delete: 'Sil'
  },

  // Campaigns
  campaigns: {
    title: 'Kampanyalar',
    subtitle: 'Kampanyalarınızı yönetin',
    noCampaigns: 'Henüz kampanya eklenmemiş',
    addNew: 'Yeni Kampanya Ekle',
    edit: 'Düzenle',
    delete: 'Sil'
  },

  // Page Content
  pageContent: {
    title: 'Sayfa İçerikleri',
    subtitle: 'Sayfa içeriklerini yönetin'
  },

  // Settings
  settings: {
    title: 'Site Ayarları',
    subtitle: 'Sitenizin genel ayarlarını yönetin',
    general: 'Genel Bilgiler',
    contact: 'İletişim Bilgileri',
    social: 'Sosyal Medya',
    seo: 'SEO Ayarları',
    background: 'Arka Plan Ayarları',
    save: 'Kaydet',
    saving: 'Kaydediliyor...',
    success: 'Ayarlar başarıyla kaydedildi!',
    error: 'Ayarlar kaydedilirken bir hata oluştu'
  }
};

export default common;
